export default "https://legacy.eskolare-development.com/images/due-payments.png";